// Import model
import { UpdateContactRequest } from '../models/UpdateContactRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdatePhoneNumberRequest } from '../models/UpdatePhoneNumberRequest';

// Import dependency serializers (for complex types)
import { UpdatePhoneNumberRequestSerializer } from './UpdatePhoneNumberRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateContactRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateContactRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateContactRequest instance
   */
  static deserialize(json: string): UpdateContactRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateContactRequest instance
   */
  static fromObject(obj: any): UpdateContactRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateContactRequest');
    }


    const instance: UpdateContactRequest = {
      role: obj['role'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      country: obj['country'] as string | undefined,
      email: obj['email'] as string | undefined,
      location: obj['location'] as any | undefined,
      parentContactId: obj['parentContactId'] as string | undefined,
      phoneNumbers: obj['phoneNumbers'] ? (obj['phoneNumbers'] as any[]).map((item: any) =>
        UpdatePhoneNumberRequestSerializer.fromObject(item)
      ) : [] as any,
      name: obj['name'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      address2: obj['address2'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateContactRequest instances
   */
  static deserializeArray(json: string): UpdateContactRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateContactRequest instance to a JSON string
   */
  static serialize(instance: UpdateContactRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateContactRequest instance to a plain object
   */
  static toObject(instance: UpdateContactRequest): any {
    return {
      'role': instance.role,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'country': instance.country,
      'email': instance.email,
      'location': instance.location,
      'parentContactId': instance.parentContactId,
      'phoneNumbers': instance.phoneNumbers?.map((item: any) =>
        UpdatePhoneNumberRequestSerializer.toObject(item)
      ),
      'name': instance.name,
      'notes': instance.notes,
      'address2': instance.address2,
    };
  }

  /**
   * Serializes an array of UpdateContactRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateContactRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
